var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6616 4.52965C16.9213 4.75695 16.9477 5.1518 16.7204 5.41157L7.97036 15.4116C7.85645 15.5418 7.69368 15.6189 7.5208 15.6247C7.34791 15.6304 7.18037 15.5643 7.05806 15.442L3.30806 11.6919C3.06398 11.4479 3.06398 11.0521 3.30806 10.8081C3.55214 10.564 3.94786 10.564 4.19194 10.8081L7.46956 14.0857L15.7796 4.58844C16.0069 4.32867 16.4018 4.30235 16.6616 4.52965Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.ad6f34dcb83e689fda869bf5b68713ed.svg";
export { ForwardRef as ReactComponent };